import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { veTokenAbi } from "@/domains/abis"

import type { TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

type ApproveVenammNftProps = {
  chainId: number
  config: Config
  veTokenAddress: Address
  venAmmAddress: Address
  account: Address
  tokenId: number
}

export const approveVenammNft = async ({
  chainId,
  config,
  veTokenAddress,
  venAmmAddress,
  account,
  tokenId,
}: ApproveVenammNftProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veTokenAbi as Abi,
        account,
        address: veTokenAddress,
        args: [venAmmAddress, BigInt(tokenId)],
        chainId,
        functionName: "approve",
      },
    })
    return result
  } catch (error: any) {
    console.error("approveVenammNft", error)
    return { success: false, error: error.message, code: error.code }
  }
}

